function PriorityLogoSVG() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.75" y="1.75" width="20.5" height="20.5" rx="5" fill="#0B5FFF" />
      <path
        d="M9 17.25V7.25C9 6.83579 9.33579 6.5 9.75 6.5H13.25C15.3211 6.5 17 8.17893 17 10.25C17 12.3211 15.3211 14 13.25 14H10.5V17.25C10.5 17.6642 10.1642 18 9.75 18C9.33579 18 9 17.6642 9 17.25ZM10.5 12.5H13.25C14.4926 12.5 15.5 11.4926 15.5 10.25C15.5 9.00736 14.4926 8 13.25 8H10.5V12.5Z"
        fill="white"
      />
    </svg>
  );
}

export default PriorityLogoSVG;
